var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "header [#1539]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Desktop---Contact-Details-(Card)",
    transform: "translate(-564.000000, -163.000000)",
    fill: "#067BC2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(45.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-View",
    transform: "translate(500.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6557377,0 C23.1225902,0 24.3114754,1.18888525 24.3114754,2.6557377 C24.3114754,4.12259016 23.1225902,5.31147541 21.6557377,5.31147541 C20.1888852,5.31147541 19,4.12259016 19,2.6557377 C19,1.18888525 20.1888852,0 21.6557377,0 L21.6557377,0 Z M21.6557377,1.7704918 C21.1679672,1.7704918 20.7704918,2.16796721 20.7704918,2.6557377 C20.7704918,3.1435082 21.1679672,3.54098361 21.6557377,3.54098361 C22.1435082,3.54098361 22.5409836,3.1435082 22.5409836,2.6557377 C22.5409836,2.16796721 22.1435082,1.7704918 21.6557377,1.7704918 L21.6557377,1.7704918 Z M19,8.6557377 L36.704918,8.6557377 L36.704918,6.8852459 L19,6.8852459 L19,8.6557377 Z M19,12 L36.704918,12 L36.704918,10.2295082 L19,10.2295082 L19,12 Z M26.0819672,1.7704918 L36.704918,1.7704918 L36.704918,0 L26.0819672,0 L26.0819672,1.7704918 Z M26.0819672,5.31147541 L36.704918,5.31147541 L36.704918,3.54098361 L26.0819672,3.54098361 L26.0819672,5.31147541 Z",
    id: "header-[#1539]"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListView);
export default __webpack_public_path__ + "static/media/icon_list_view.54859110c7cf40eb25b6f1b6660092b4.svg";
export { ForwardRef as ReactComponent };